import axios from "axios";

const getDoctorUzmanlikList = async (baseUrl, token) => {

    const config = {
        headers: { Authorization: `Bearer ${token}` }
    };

    let getResponse = null

    await axios.get(baseUrl + `/doctor/department`, config)
        .then((res) => {
            getResponse = {
                status: res.data.status,
                result: res.data.data
            }
        }).catch((error) => {
            if (error.response !== undefined) {
                getResponse = {
                    status: error.response.status,
                    result:  error.response.status
                }
            }
        });
    return getResponse
}

export default getDoctorUzmanlikList;